import React, { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import { TextField } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import frLocale from 'date-fns/locale/fr';
import {
  DocumentContainer,
  StyledDiv,
} from 'containers/ExpertExpertise/Dialogs/styles';
import DialogMission from 'containers/ExpertExpertise/Dialogs/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/ExpertExpertise/messages';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { DATE_FORMAT, DOCUMENT_TYPES } from 'constants/global';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import {
  DOCUMENT,
  EMPTY_DOCUMENT,
  MISSION_POSTPONE_STATUS,
  MISSION_POSTPONE_TYPE,
  FEE_NOTE_STEP,
} from 'containers/data-structure';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { get, isEmpty, isNil } from 'lodash';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import SuccessDialog from 'components/SuccessDialog';
import * as featureService from 'features/fflip-helpers';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import { FEATURES } from 'features/features';
import { PAGES } from 'routes';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { isMissionPostPoneContainsNullDate } from 'containers/ExpertExpertise/Recap/utils';
import InvoiceFeeNoteDialog from 'components/InvoiceFeeNoteDialog';
import { isAllValuesIsNil } from 'helpers/utils';
import { getLimitInvoiceIntervenant } from 'services/utils';
import { useSelector } from 'react-redux';
import { makeSelectFeeNotes } from 'containers/LawyerFeeNote/selectors';
import { getPendingFeeNotesByNoticeId } from 'containers/ExpertExpertise/Dialogs/utils';
import { FeeNoteType } from 'typings/globalTypes';

export interface NoticeDeficiencyDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  mission: any;
  missionPostPoneExpertise: any;
  recap: any;
  listings: any;
}

const NoticeDeficiencyDialog: React.FC<NoticeDeficiencyDialogProps> = (
  props,
): JSX.Element => {
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState(null);
  const [missionDate, setMissionDate] = useState(null);
  const [noticeDeficiency, setNoticeDeficiency] = useState<any>({
    ...EMPTY_DOCUMENT,
  });
  const [isSuccessPopinOpen, setIsSuccessPopinOpen] = React.useState<boolean>(
    false,
  );
  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = React.useState(false);
  const [
    decisionGenerationFeeNote,
    setDecisionGenerationFeeNote,
  ] = React.useState(null);
  const [invoiceDocument, setInvoiceDocument] = React.useState({});
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);
  const [invoiceFeeNotes, setInvoiceFeeNotes] = useState([]);
  const currentFeeNoteIndexRef = useRef<number>(0);
  const [currentFeeNoteIndex, setCurrentFeeNoteIndex] = useState<number | null>(
    null,
  );
  useEffect(() => {
    if (currentFeeNoteIndex !== null) {
      currentFeeNoteIndexRef.current = currentFeeNoteIndex;
    }
  }, [currentFeeNoteIndex]);
  const [invoiceDocumentUpdate, setInvoiceDocumentUpdate] = useState({});
  const [invoiceNumberUpdate, setInvoiceNumberUpdate] = useState(null);
  const [invoiceDateUpdate, setInvoiceDateUpdate] = useState(null);
  const feeNotesStore = useSelector(makeSelectFeeNotes());
  const [feeNotes, setFeeNotes] = useState([]);
  const [
    openInvoiceUpdateFeeNoteInfoDialog,
    setOpenInvoiceUpdateFeeNoteInfoDialog,
  ] = useState(false);
  const handleCloseInvoiceUpdateFeeNote = () => {
    setOpenInvoiceUpdateFeeNoteInfoDialog(false);
  };
  const handleValidateUpdateInvoice = () => {
    const currentItem = feeNotes[currentFeeNoteIndexRef.current];
    const invoiceFeeNoteId = get(currentItem, 'invoiceFeeNote.id');
    const updatedInvoiceFeeNotes = [
      ...invoiceFeeNotes,
      {
        id: invoiceFeeNoteId,
        invoiceNumber: invoiceNumberUpdate,
        invoiceDate: invoiceDateUpdate,
        receptionDate: moment().format('YYYY-MM-DD'),
        ...invoiceDocumentUpdate,
      },
    ];
    setInvoiceFeeNotes(updatedInvoiceFeeNotes as any);

    setInvoiceNumberUpdate(null);
    setInvoiceDocumentUpdate({});
    setInvoiceDateUpdate(null);
    setOpenInvoiceUpdateFeeNoteInfoDialog(false);
    if (
      updatedInvoiceFeeNotes.length ===
      feeNotes.map((el: any) => el.invoiceFeeNote).length
    ) {
      setCurrentFeeNoteIndex(null);
      handleUpdate(updatedInvoiceFeeNotes);
    } else {
      currentFeeNoteIndexRef.current = currentFeeNoteIndexRef.current + 1;
      setCurrentFeeNoteIndex(currentFeeNoteIndexRef.current);
      setOpenInvoiceUpdateFeeNoteInfoDialog(true);
    }
  };

  useDeepCompareEffect(() => {
    if (!isEmpty(props.recap)) {
      setDescription(get(props.recap, 'missionPostPone.description'));
      setReason(get(props.recap, 'missionPostPone.reason'));
      setNoticeDeficiency(props.recap);
      setMissionDate(get(props.recap, 'mission.missionDate'));
      setFeeNotes(
        getPendingFeeNotesByNoticeId(
          feeNotesStore,
          get(props.recap, 'missionPostPone.id'),
        ) as any,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.recap]);
  const { onClose, open } = props;

  const handleChangeReason = (event: any) => {
    setReason(event.target.value);
  };
  const successCallBack = () => {
    toast.success(translate(messages.successToastNoticeTitle, props));
    props.onClose();
    setIsSuccessPopinOpen(false);
  };

  const successCallBackUpdate = () => {
    toast.success(
      translate(messages.successToastUpdatedNoticeTitle, props, {
        type: get(props.recap, 'missionPostPone.type'),
      }),
    );
    props.onClose();
    setIsSuccessPopinOpen(false);
  };
  const deleteDoc = () => {
    setNoticeDeficiency({ ...document, url: '' });
  };

  const handleDateChange = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const formatedDate = moment(theDate as Date).format(DATE_FORMAT);

    setMissionDate(formatedDate as any);
  };

  const onSubmit = (withFeeNote: boolean) => {
    props.validateDialog(
      withFeeNote
        ? {
            ...noticeDeficiency,
            [DOCUMENT.IS_INDEXED]: false,
            decisionGenerationFeeNote: decisionGenerationFeeNote,
            missionId: get(props.mission, 'id'),

            feeNote: {
              step: FEE_NOTE_STEP.NOTICE_DEFICIENCY,
              codeIntervenant: currentIntervenantStorage.get()?.sagis_code,
              feeNoteMission: {
                missionId: get(props.mission, 'id'),
              },
              invoiceFeeNote:
                featureService.hasFeature(
                  FEATURES.BILLING_INFO_FEE_NOTE_EXPERT,
                ) &&
                !isAllValuesIsNil({
                  invoiceNumber: invoiceNumber,
                  invoiceDate: invoiceDate,
                  ...invoiceDocument,
                })
                  ? {
                      codeIntervenant:
                        currentIntervenantStorage.get() &&
                        currentIntervenantStorage.get().sagis_code,
                      createdBy:
                        currentIntervenantStorage?.get() &&
                        currentIntervenantStorage?.get()?.preferred_username,
                      invoiceNumber: invoiceNumber,
                      invoiceDate:
                        invoiceDate === 'Invalid date' ? null : invoiceDate,
                      receptionDate: moment().format('YYYY-MM-DD'),
                      ...invoiceDocument,
                      isIndexed: false,
                    }
                  : undefined,
            },
            missionDate: missionDate,
            isInboxesActive: featureService.hasFeature(
              FEATURES.ATTRIBUTION_INBOXES_MANAGER,
            ),
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
            missionPostPone: {
              missionId: get(props.mission, 'id'),
              reason: reason,
              description: description,
              status: MISSION_POSTPONE_STATUS.PENDING,
              type: MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY,
              createdBy: currentIntervenantStorage.get()?.sagis_code,
            },
          }
        : {
            ...noticeDeficiency,
            decisionGenerationFeeNote: false,
            [DOCUMENT.IS_INDEXED]: false,
            missionId: get(props.mission, 'id'),
            missionDate: missionDate,
            isInboxesActive: featureService.hasFeature(
              FEATURES.ATTRIBUTION_INBOXES_MANAGER,
            ),
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
            missionPostPone: {
              missionId: get(props.mission, 'id'),
              reason: reason,
              description: description,
              status: MISSION_POSTPONE_STATUS.PENDING,
              type: MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY,
              createdBy: currentIntervenantStorage.get()?.sagis_code,
            },
          },
      successCallBack,
    );
  };

  const handleOpenInvoicesInfoDialog = () => {
    setIsSuccessPopinOpen(false);
    setOpenInvoiceFeeNoteInfoDialog(true);
  };
  const handleUpdate = (updatedInvoiceFeeNotes?: any) => {
    props.validateDialog(
      {
        document: {
          ...noticeDeficiency,
          isUpdated: true,
          id: get(props.recap, 'id'),
          missionId: get(props.mission, 'id'),
        },
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        id: get(props.recap, 'missionPostPone.id'),
        missionId: get(props.mission, 'id'),
        missionDate: missionDate,
        reason: reason,
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        description: description,
        invoiceFeeNotes: updatedInvoiceFeeNotes,
        status: MISSION_POSTPONE_STATUS.PENDING,
        type: MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY,
      },
      successCallBackUpdate,
    );
  };
  const handleValidationUpdate = () => {
    if (
      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
      !isEmpty(feeNotes) &&
      currentIntervenantStorage.get()
    ) {
      setOpenInvoiceUpdateFeeNoteInfoDialog(true);
    } else {
      handleUpdate();
    }
  };

  const onValidate = () => {
    setIsSuccessPopinOpen(true);
  };

  const doNotGenerateFeeNote = () => {
    onSubmit(false);
  };

  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleValidateInvoice = () => {
    onSubmit(true);
    setOpenInvoiceFeeNoteInfoDialog(false);
  };
  return (
    <>
      <DialogMission
        open={open}
        onClose={onClose}
        validateDialog={
          !isEmpty(props.recap) ? handleValidationUpdate : onValidate
        }
        title={translate({ ...messages.noticeDeficiency }, props)}
        content={
          <StyledDiv>
            <TextField
              onChange={handleChangeReason}
              name={'reason'}
              value={reason}
              label={translate({ ...messages.reason }, props)}
              className="input"
              multiline
              fullWidth
            />
            {(isNil(get(props.mission, 'missionDate')) ||
              (isMissionPostPoneContainsNullDate(
                props.missionPostPoneExpertise,
              ) &&
                !isEmpty(props.missionPostPoneExpertise))) && (
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  invalidDateMessage=""
                  format="dd/MM/yyyy"
                  id="lossDate"
                  onChange={handleDateChange}
                  name={'mission-date'}
                  value={dateStringToLocalDate(missionDate)}
                  label={translate({ ...messages.missionDate }, props)}
                  className="input"
                  error={missionDate === 'Invalid date'}
                  helperText={
                    missionDate === 'Invalid date'
                      ? translate(messages.invalidDate, props)
                      : ''
                  }
                />
              </MuiPickersUtilsProvider>
            )}
            <span style={{ fontSize: '13px', color: 'red' }}>
              {translate({ ...messages.documentStampedTitle }, props)}
            </span>
            <DocumentContainer>
              <UploadDocumentBloc
                index={0}
                document={noticeDeficiency}
                setDocument={setNoticeDeficiency}
                resetUploadedDocument={props.resetUploadedDocument}
                uploadDocument={props.uploadDocument}
                uploadedDocument={props.uploadedDocument}
                docType={DOCUMENT_TYPES.NOTICE_DEFICIENCY}
                deleteDoc={deleteDoc}
              />
            </DocumentContainer>
          </StyledDiv>
        }
        disabled={
          !reason || !noticeDeficiency.url || missionDate === 'Invalid date'
        }
      />
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE_EXPERT) ? (
        <InvoiceFeeNoteDialog
          open={isSuccessPopinOpen}
          onClose={() => setIsSuccessPopinOpen(false)}
          decisionGenerationFeeNote={decisionGenerationFeeNote}
          setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
          handleValidate={
            decisionGenerationFeeNote
              ? handleOpenInvoicesInfoDialog
              : doNotGenerateFeeNote
          }
          shouldDisplayFirmReferenceField={false}
          lawyerFirmRef={null}
          setLawyerFirmRef={() => {}}
        />
      ) : (
        <SuccessDialog
          title={translate(messages.noticeCreateFeeNote, props)}
          secondaryButtonTitle={translate(
            messages.successDialogSecondaryButtonTitle,
            props,
          )}
          primaryButtonTitle={
            featureService.hasFeature(FEATURES.FEE_NOTE)
              ? translate(messages.successAppealAdd, props)
              : translate(messages.successDialogPrimaryButtonTitle, props)
          }
          tertiaryButtonTitle={translate(
            { ...messages.doNotGenerateFeeNote },
            props,
          )}
          onTertiaryClick={doNotGenerateFeeNote}
          open={isSuccessPopinOpen}
          onClose={setIsSuccessPopinOpen}
          homePath={PAGES.EXPERT_HOME}
          onPrimaryClick={() => onSubmit(true)}
          isExpertReport={false}
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE_EXPERT) && (
        <InvoiceInfoDialog
          open={openInvoiceFeeNoteInfoDialog}
          onClose={handleCloseInvoiceFeeNote}
          handleValidate={handleValidateInvoice}
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          setInvoiceNumber={setInvoiceNumber}
          setInvoiceDate={setInvoiceDate}
          resetUploadedDocument={props.resetUploadedDocument}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          invoiceDocument={invoiceDocument}
          setInvoiceDocument={setInvoiceDocument}
          limitInvoiceDate={getLimitInvoiceIntervenant(
            get(props.listings, 'appConfig', []),
          )}
        />
      )}
      {featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
      !isEmpty(feeNotes) &&
      feeNotes ? (
        feeNotes.map((item: FeeNoteType) => (
          <InvoiceInfoDialog
            open={openInvoiceUpdateFeeNoteInfoDialog}
            onClose={handleCloseInvoiceUpdateFeeNote}
            handleValidate={handleValidateUpdateInvoice}
            invoiceNumber={invoiceNumberUpdate}
            invoiceDate={invoiceDateUpdate}
            setInvoiceNumber={setInvoiceNumberUpdate}
            setInvoiceDate={setInvoiceDateUpdate}
            resetUploadedDocument={props.resetUploadedDocument}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            invoiceDocument={invoiceDocumentUpdate}
            setInvoiceDocument={setInvoiceDocumentUpdate}
            displayUpdateTitle={true}
            isManager={false}
            limitInvoiceDate={getLimitInvoiceIntervenant(
              get(props.listings, 'appConfig', []),
            )}
          />
        ))
      ) : (
        <></>
      )}
    </>
  );
};

NoticeDeficiencyDialog.defaultProps = {
  open: false,
};

export default injectIntl(NoticeDeficiencyDialog);
